export enum GoogleTagManagerItemEditMode {
  Remove,
  Add,
}
